import { useState } from "react";
import useAdminAuth from "../hooks/UseAdminAuth";
import "../styles/loginAdmin.css";
import { validateEmail, validatePassword } from "../utils/validationUtils";

const LoginAdmin = () => {
  const { signInAdmin } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validateForm = () => {
    let valid = true;
    let emailError = validateEmail(email);
    let passwordError = validatePassword(password);

    let errors = {
      email: emailError,
      password: passwordError,
    };

    setIsEmailValid(!emailError);
    setIsPasswordValid(!passwordError);

    if (emailError || passwordError) {
      valid = false;
    }

    setErrors(errors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        await signInAdmin(email, password);
      } catch (error) {
        setErrors({
          email: "Incorrect email or password.",
          password: "Incorrect email or password.",
        });
        setEmail("");
        setPassword("");
      }
    }
  };

  return (
    <div
      className="container-fluid vh-100 d-flex overflow-hidden"
      id="container-login-admin"
    >
      <div className="row flex-grow-1">
        <div className="col-md-6 d-none d-md-flex bg-image text-white justify-content-center align-items-center">
          <div className="text-center">
            <h1 className="display-4">Hello HRD UPJ!</h1>
            <p className="mt-auto text-sm-start">
              &copy; 2024 Universitas Pembangunan Jaya. All rights reserved.
            </p>
          </div>
        </div>

        <div className="col-md-6 d-flex justify-content-center align-items-center">
          <div className="w-75">
            <h2 className="mb-4">Selamat Datang Kembali!</h2>
            <p className="mb-4">Silahkan Masukan Email dan Password.</p>
            <form onSubmit={handleSubmit} noValidate>
              <div className="mb-3">
                <input
                  required
                  type="email"
                  className={`form-control ${
                    errors.email ? "is-invalid" : isEmailValid ? "is-valid" : ""
                  }`}
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    required
                    type={showPassword ? "text" : "password"}
                    className={`form-control pe-5 ${
                      errors.password
                        ? "is-invalid"
                        : isPasswordValid
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <i
                    className={`bi ${
                      showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"
                    } position-absolute top-50 end-0 translate-middle-y me-3`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword(!showPassword)}
                  ></i>
                </div>
                {errors.password && (
                  <div className="invalid-feedback d-block">
                    {errors.password}
                  </div>
                )}
              </div>
              <button type="submit" className="btn btn-primary w-100 mb-2">
                Sign In
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginAdmin;
